<script setup lang="ts">
import { onUnmounted, ref, watchEffect } from "vue";
import { mouseEnter$, mouseLeave$ } from "@zyzgroup/core-web";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(defineProps<{}>(), {});

const emits = defineEmits<{
  (event: "enter", e: MouseEvent): void;
  (event: "leave", e: MouseEvent): void;
}>();

const r = ref();

const isEnter = ref(false);

let s1;
let s2;
watchEffect(() => {
  if (!r.value) {
    return;
  }
  s1?.unsubscribe();
  s1 = mouseEnter$(r.value).subscribe((e) => {
    isEnter.value = true;
    emits("enter", e);
  });
  s2?.unsubscribe();
  s2 = mouseLeave$(r.value).subscribe((e) => {
    isEnter.value = false;
    emits("leave", e);
  });
});

onUnmounted(() => {
  s1?.unsubscribe();
  s2?.unsubscribe();
});

defineExpose({});
</script>

<template>
  <div
    ref="r"
    class="mouse"
    :style="{ display: 'inline-block', cursor: isEnter ? 'pointer' : 'auto' }"
  >
    <slot></slot>
  </div>
</template>

<style></style>
